export default "__VITE_ASSET__e2d49ca4__"